var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.8766L13.425 11.8016L18 6.00156H7.62502L6.12502 4.50156H19.3C19.65 4.50156 19.9084 4.6599 20.075 4.97656C20.2417 5.29323 20.2084 5.59323 19.975 5.87656L14.5 12.8766ZM20.325 22.9766L14 16.6516V19.5016C14 19.7849 13.9042 20.0224 13.7125 20.2141C13.5209 20.4057 13.2834 20.5016 13 20.5016H11C10.7167 20.5016 10.4792 20.4057 10.2875 20.2141C10.0959 20.0224 10 19.7849 10 19.5016V12.6516L1.52502 4.17656L2.60002 3.10156L21.4 21.9016L20.325 22.9766Z",
    fill: "#0C8CE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ef8ccd0a1fc70dff45f369269dd348ee.svg";
export { ForwardRef as ReactComponent };